import React, { useState, useEffect, useRef, forwardRef } from "react";
import PricingCard from "./PricingCard";
import "./Pricing.css";

const Pricing = forwardRef((props, ref) => {
  const [isMobile, setIsMobile] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const carouselRef = useRef(null);

  // Check if we're on mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Handle scroll position for dots
  useEffect(() => {
    if (!isMobile || !carouselRef.current) return;

    const handleScroll = () => {
      const scrollPosition = carouselRef.current.scrollLeft;
      const cardWidth = 300 + 16; // card width + gap
      const newIndex = Math.round(scrollPosition / cardWidth);
      setActiveIndex(newIndex);
    };

    const carousel = carouselRef.current;
    carousel.addEventListener("scroll", handleScroll);
    return () => carousel.removeEventListener("scroll", handleScroll);
  }, [isMobile]);

  const scrollToIndex = (index) => {
    if (!carouselRef.current) return;
    const cardWidth = 300 + 16; // card width + gap
    carouselRef.current.scrollTo({
      left: index * cardWidth,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  const plans = ["Free", "Pro"];

  return (
    <div className="pricing-page-section" ref={ref} id="pricing">
      <div className="pricing-page-header">
        <h2>Simple, Transparent Pricing</h2>
        <p className="pricing-page-subtitle">
          Start with our free plan or unlock unlimited features with Pro
        </p>
      </div>
      <div className="pricing-page-cards" ref={carouselRef}>
        {plans.map((plan) => (
          <div key={plan} className="pricing-page-carousel-item">
            <PricingCard plan={plan} />
          </div>
        ))}
      </div>
      {isMobile && (
        <div className="pricing-page-carousel-dots">
          {plans.map((_, index) => (
            <button
              key={index}
              className={`pricing-page-carousel-dot ${
                index === activeIndex ? "active" : ""
              }`}
              onClick={() => scrollToIndex(index)}
              aria-label={`View ${plans[index]} plan`}
            />
          ))}
        </div>
      )}
      <div className="pricing-page-footer">
        <p>All plans include our core tax calculation features</p>
      </div>
    </div>
  );
});

export default Pricing;
